var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8SendWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.13333,-0.00001) scale(10.66667,10.66667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,3c-0.55228,0 -1,0.44772 -1,1v5.5957c0,0.514 0.38939,0.94314 0.90039,0.99414l14.09961,1.41016l-14.09961,1.41016c-0.511,0.051 -0.90039,0.48014 -0.90039,0.99414v5.5957c0,0.55228 0.44772,1 1,1c0.19092,0.00044 0.37797,-0.05378 0.53906,-0.15625c0.00065,-0.00065 0.0013,-0.0013 0.00195,-0.00195l17.79883,-7.89844l-0.00195,-0.00391c0.39659,-0.14238 0.66138,-0.51808 0.66211,-0.93945c-0.00073,-0.42137 -0.26552,-0.79708 -0.66211,-0.93945l0.00195,-0.00391l-17.8125,-7.9043c-0.15813,-0.09898 -0.34079,-0.15174 -0.52734,-0.15234z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8SendWhite);
export default __webpack_public_path__ + "static/media/icons8-send-white.f70c03cba1fab21f8bee627a5fea960d.svg";
export { ForwardRef as ReactComponent };